import { api } from '@@/services//api';

export const propertyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchPartnerProperties: builder.query<
      { docs: Alacaza.Property[] },
      { page: number; limit: number }
    >({
      query: ({ page, limit }) =>
        `/partners/properties?page=${page}&limit=${limit}`,
      providesTags: ['Properties'],
    }),
    fetchProperty: builder.query<Alacaza.Property, string>({
      query: (propertyId) => `/partners/properties/${propertyId}`,
      providesTags: ['Properties'],
    }),
    searchPartnerProperties: builder.query<Alacaza.Property[], string>({
      query: (query) => `/partners/properties/search?query=${query}`,
    }),
    fetchPropertyResidents: builder.query<Alacaza.Resident[], string>({
      query: (propertyId) => `/partners/properties/${propertyId}/residents`,
    }),
    addPropertyIncidentAdmin: builder.mutation<
      Alacaza.Property,
      { propertyId: string; body: Omit<Alacaza.PropertyAdmin, 'id'> }
    >({
      query: ({ propertyId, body }) => ({
        url: `/partners/properties/${propertyId}/admins`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Properties'],
    }),
    patchPropertyIncidentAdmin: builder.mutation<
      Alacaza.Property,
      {
        propertyId: string;
        propertyAdminId: string;
        body: Partial<Alacaza.PropertyAdmin>;
      }
    >({
      query: ({ propertyId, propertyAdminId, body }) => ({
        url: `/partners/properties/${propertyId}/admins/${propertyAdminId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Properties'],
    }),
    deletePropertyIncidentAdmin: builder.mutation<
      Alacaza.Property,
      { propertyId: string; propertyAdminId: string }
    >({
      query: ({ propertyId, propertyAdminId }) => ({
        url: `/partners/properties/${propertyId}/admins/${propertyAdminId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Properties'],
    }),
  }),
});

export const {
  useFetchPartnerPropertiesQuery,
  useFetchPropertyQuery,
  useSearchPartnerPropertiesQuery,
  useDeletePropertyIncidentAdminMutation,
  useAddPropertyIncidentAdminMutation,
  usePatchPropertyIncidentAdminMutation,
  useFetchPropertyResidentsQuery,
} = propertyApi;
